export const SHOW_SENSITIVE_MODAL = 'SHOW_SENSITIVE_MODAL';
export const HIDE_SENSITIVE_MODAL = 'HIDE_SENSITIVE_MODAL';